import { render } from "./property-nearbyhomevalues.vue?vue&type=template&id=ce33a294"
import script from "./property-nearbyhomevalues.js?vue&type=script&lang=js"
export * from "./property-nearbyhomevalues.js?vue&type=script&lang=js"

import "./property-nearbyhomevalues.vue?vue&type=style&index=0&id=ce33a294&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__